export default __webpack_public_path__ + "media/images/react_icons/property/brush-6d9b501878cb4eba916e48f3113a1a5f.svg";